import React, { useContext, useEffect, useRef, useState } from "react";
import "./Sale_products.css";
import Filter_btn from "../Common-Component/common_btn/filter_btn/Filter_btn";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { Col, Container, Row } from "react-bootstrap";
import DoubleHeading from "../Common-Component/DoubleHeading/DoubleHeading";
import { Context } from "../../utils/context";
import {
  AllProductsData,
  Products,
  ProductsSale,
} from "../../utils/apis/Product/Product";
import Product_Card from "../Common-Component/Product_Card/Product_Card";
import Filter_offcanvas from "../All-Products/filter_offcanvas/Filter_offcanvas";
import Loader_lottie from "../Animation/Loader_lottie/Loader_lottie";
import { ShimmerThumbnail } from "react-shimmer-effects";

function Sale_products() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { IMG_URL, setShimmerLoader, shimmerLoader } = useContext(Context);
  const [products, setProducts] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [showSort, setShowSort] = useState(false);
  // const [numToShow, setNumToShow] = useState(5);
  const [numToShow, setNumToShow] = useState(20); // Number of products to show initially
  const [showAll, setShowAll] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 575);
  const sectionRef = useRef(null);
  const [sizeSearach, setSizeSearch] = useState([]);
  const [sortOrder, setSortOrder] = useState("");
  const [category, setCategory] = useState([]);
  const [reset, setReset] = useState();
  const getProduct = async () => {
    setShimmerLoader(true);
    const res = await ProductsSale(
      category,
      "",
      "",
      "",
      "",
      sortOrder,
      sizeSearach
    );
    if (res?.success) {
      setProducts(res?.data?.data);
      // set default based on screen size
      // setNumToShow(window.innerWidth < 575 ? 4 : 5);
      // setShowAll(false);
      setShimmerLoader(false);
    }
  };

  useEffect(() => {
    getProduct();

    // const handleResize = () => {
    //   const mobile = window.innerWidth < 575;
    //   setIsMobile(mobile);
    //   setNumToShow(mobile ? 4 : 5); // keep consistent
    //   setShowAll(false);
    // };

    // window.addEventListener("resize", handleResize);
    // return () => window.removeEventListener("resize", handleResize);
  }, [reset]);

  const toggleShowAll = () => {
    if (isMobile) {
      if (numToShow >= products.length) {
        setNumToShow(2);
        // Scroll to the top of the products section
        sectionRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      } else {
        setNumToShow((prev) => Math.min(prev + 10, products.length));
      }
    } else {
      if (showAll) {
        setNumToShow(5);
        setShowAll(false);
        // Scroll to the top of the products section
        sectionRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      } else {
        setNumToShow(products.length);
        setShowAll(true);
      }
    }
  };

  const handlePriceHighToLow = async (value) => {
    await setSortOrder(value);
  };

  const handleShow = () => {
    setShowFilter(true);
    setShowSort(false);
  };

  const handleClose = () => {
    setShowFilter(false);
    setShowSort(false);
  };

  // useEffect(() => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: "smooth",
  //   });
  // });

  return (
    <>
      <section className="All-Products Sale_products">
        <div className="filter_holder">
          {/* <div className="filter_btn_holder">
            <Filter_btn btnText="Filter" icon={faFilter} onClick={handleShow} />
          </div> */}

          {/* <div className="filter_btn_holder">
              <Filter_btn btnText="Sort" icon={faBarsStaggered} onClick={handleShowSort} />
            </div> */}
        </div>

        <Container fluid>
          <div className="mb-3 mt-3">
            <DoubleHeading heading={"Sale"} />
          </div>

          {/* Desktop view */}
          <div
            className="desktop_view_product_category_slider"
            ref={sectionRef}>
            {shimmerLoader ? (
              <ShimmerThumbnail rounded />
            ) : // <div className="loader-container text-center my-5">
              //   <Loader_lottie />
              //   <p className="mt-2">Product Loading ...</p>
              // </div>
              products.length > 0 ? (
                <Row>
                  {products.slice(0, numToShow).map((product, index) => {
                    const price =
                      product?.product_multiple_mains?.[0]
                        ?.product_multiple_variants?.[0]?.mrp ||
                      product?.product_variants?.[0]?.mrp;

                    const cutprice =
                      product?.product_multiple_mains?.[0]
                        ?.product_multiple_variants?.[0]?.cutting_price ||
                      product?.product_variants?.[0]?.cutting_price;

                    return (
                      <Col
                        key={index}
                        xxl={3}
                        xl={3}
                        lg={3}
                        md={4}
                        sm={4}
                        xs={6}
                        className="custom_class_product">
                        <Product_Card
                          image={IMG_URL + product?.image1}
                          text={product?.name}
                          product_id={product?.id}
                          subText={product?.short_description}
                          price={price}
                          cutprice={cutprice}
                          newest={product?.newest}
                          variant_id={product?.product_variants?.[0]?.id}
                          m_variant_id={
                            product?.product_multiple_mains?.[0]
                              ?.product_multiple_variants?.[0]?.id
                          }
                        />
                      </Col>
                    );
                  })}
                </Row>
              ) : (
                <div className="text-center my-5">
                  <p style={{ fontSize: "48px", marginBottom: "10px" }}>🛍️</p>
                  <h5 style={{ color: "#444", fontWeight: "600" }}>
                    No Products Found
                  </h5>
                  <p style={{ color: "#777", marginTop: "6px" }}>
                    Try adjusting your filters or search term.
                  </p>
                </div>
              )}
          </div>

          {/* Mobile view */}
          <div className="mobile_view_product_category_slider" ref={sectionRef}>
            <Row>
              {shimmerLoader ? (
                <ShimmerThumbnail rounded />
              ) : // <div className="loader-container text-center my-5">
                //   <Loader_lottie />
                //   <p className="mt-2">Loading ...</p>
                // </div>
                products.length > 0 ? (
                  products.slice(0, numToShow).map((product, index) => {
                    const price =
                      product?.product_multiple_mains?.[0]
                        ?.product_multiple_variants?.[0]?.mrp ||
                      product?.product_variants?.[0]?.mrp;

                    const cutprice =
                      product?.product_multiple_mains?.[0]
                        ?.product_multiple_variants?.[0]?.cutting_price ||
                      product?.product_variants?.[0]?.cutting_price;

                    return (
                      <Col
                        key={index}
                        xxl={3}
                        xl={3}
                        lg={3}
                        md={4}
                        sm={4}
                        xs={6}
                        className="custom_class_product">
                        <Product_Card
                          image={IMG_URL + product?.image1}
                          text={product?.name}
                          product_id={product?.id}
                          subText={product?.short_description}
                          price={price}
                          cutprice={cutprice}
                          newest={product?.newest}
                          variant_id={product?.product_variants?.[0]?.id}
                          m_variant_id={
                            product?.product_multiple_mains?.[0]
                              ?.product_multiple_variants?.[0]?.id
                          }
                        />
                      </Col>
                    );
                  })
                ) : (
                  <div className="text-center my-5">
                    <p style={{ fontSize: "48px", marginBottom: "10px" }}>🛍️</p>
                    <h5 style={{ color: "#444", fontWeight: "600" }}>
                      No Products Found
                    </h5>
                    <p style={{ color: "#777", marginTop: "6px" }}>
                      Try adjusting your filters or search term.
                    </p>
                  </div>
                )}
            </Row>
          </div>

          {/* View All/ View Less Button */}
          {products.length > 0 && (
            <div className="view-all mb-5" onClick={toggleShowAll}>
              <p>
                {isMobile
                  ? numToShow >= products.length
                    ? "View Less"
                    : "View More"
                  : showAll
                    ? "View Less"
                    : "View All"}
              </p>
            </div>
          )}
        </Container>
      </section>

      <Filter_offcanvas
        reset={reset}
        setReset={setReset}
        getProduct={getProduct}
        sortOrder={sortOrder}
        show={showFilter}
        handlePriceHighToLow={handlePriceHighToLow}
        setCategory={setCategory}
        category={category}
        handleClose={handleClose}
        sizeSearach={sizeSearach}
        setSizeSearch={setSizeSearch}
      />
      {/* <Sort_offcanvas show={showSort} handleClose={handleCloseSort} /> */}
    </>
  );
}

export default Sale_products;
